import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable( {
  providedIn: 'root',
} )
export class MailService {
  constructor( private http: HttpClient ) {
  }

  sendContactUsMail( params: any ) {
    return this.http.post<any>( `${ environment.serverUrl }/mail/contact`, { params } );
  }
}
